import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { FiX, FiZoomIn } from "react-icons/fi";

const SalesViewModal = ({ open, onClose, data }) => {
  // console.log("data", data);
  if (!data) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ position: "relative", pr: 6 }}>
        <div className="flex items-center justify-between">
          <div> Sales Details for {data.client_name || "-"}</div>
          <div onClick={onClose} className="text-xl cursor-pointer">
            X
          </div>
        </div>
        {/* <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[600],
          }}
        >
          <FiX />
        </IconButton> */}
      </DialogTitle>

      <DialogContent className="space-y-6">
        {/* General Client & Agent Info */}
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <strong>Client Name:</strong> {data.client_name || "-"}
          </div>
          <div>
            <strong>Client Ref:</strong> {data.client_ref || "-"}
          </div>
          <div>
            <strong>Agent Name:</strong> {data.agentname || "-"}
          </div>
          <div>
            <strong>Agent Ref:</strong> {data.agentref || "-"}
          </div>
          <div>
            <strong>Seller Name:</strong> {data.seller_name || "-"}
          </div>
          <div>
            <strong>Seller Mobile:</strong> {data.seller_mobile || "-"}
          </div>
          <div>
            <strong>Online/Offline:</strong> {data.online_or_offline || "-"}
          </div>
        </div>

        {/* Trip Info */}
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <strong>Arrival:</strong> {data.arrival || "-"}
          </div>
          <div>
            <strong>Arrival Via:</strong> {data.arrival_via || "-"}
          </div>
          <div>
            <strong>Departure:</strong> {data.departure || "-"}
          </div>
          <div>
            <strong>Departure Via:</strong> {data.departure_via || "-"}
          </div>
          <div>
            <strong>Start Date:</strong> {data.start_date || "-"}
          </div>
          <div>
            <strong>End Date:</strong> {data.end_date || "-"}
          </div>
          <div>
            <strong>Selling Price:</strong>{" "}
            {parseFloat(data.selling_price || 0).toFixed(2)}
          </div>
          <div>
            <strong>Receivable Amt:</strong>{" "}
            {parseFloat(data.receivable_amt || 0).toFixed(2)}
          </div>
          <div>
            <strong>Balance Amt:</strong>{" "}
            {parseFloat(data.balance_amt || 0).toFixed(2)}
          </div>
        </div>

        {/* Company Info */}
        {Array.isArray(data.company_info) && data.company_info.length > 0 && (
          <div className="text-sm">
            <strong>Company Info:</strong>
            <ul className="list-disc ml-6 mt-1">
              {data.company_info.map((c, idx) => (
                <li key={idx}>Name: {c.name || "-"}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Sales Records Table */}
        <div>
          <h3 className="text-md font-semibold mb-2">Sales Records</h3>
          {Array.isArray(data.sales_records) &&
          data.sales_records.length > 0 ? (
            <table className="w-full border text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-2 py-1 border">#</th>
                  <th className="px-2 py-1 border">Received Date</th>
                  <th className="px-2 py-1 border">Payment Type</th>
                  <th className="px-2 py-1 border">Booking ID</th>
                  <th className="px-2 py-1 border">Received Amount</th>
                  <th className="px-2 py-1 border">Balance</th>
                  <th className="px-2 py-1 border">Status</th>
                  <th className="px-2 py-1 border">Remark</th>
                </tr>
              </thead>
              <tbody>
                {data.sales_records.map((record, idx) => (
                  <tr key={record.id || idx}>
                    <td className="border px-2 py-1 text-center">{idx + 1}</td>

                    <td className="border px-2 py-1 text-center">
                      {record.received_date || "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {record.payment_type || "-"}
                    </td>

                    {/* Adjusted From */}
                    {/* <td className="border px-2 py-1 text-center whitespace-pre-line">
                      {record?.payment_type === "Adjust" &&
                      Array.isArray(record?.adjusted_from) &&
                      record.adjusted_from.length > 0
                        ? record.adjusted_from
                            .map((booking) => booking?.from_ref_no)
                            .filter(Boolean)
                            .join("\n")
                        : "-"}
                    </td> */}

                    <td className="border px-2 py-1 whitespace-pre-line">
                      {record?.payment_type === "Adjust" &&
                      Array.isArray(record?.adjusted_from) &&
                      record.adjusted_from.length > 0 ? (
                        <div className="flex flex-col gap-1">
                          {record.adjusted_from.map((booking, index) => (
                            <div key={index}>
                              {booking?.from_ref_no} - ₹
                              {parseFloat(booking?.used_amount || 0).toFixed(2)}
                            </div>
                          ))}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {parseFloat(record.received_amt || 0).toFixed(2)}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {parseFloat(record.balance_amt || 0).toFixed(2)}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {record.status || "-"}
                    </td>

                    <td className="border px-2 py-1">{record.remark || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-sm">No sales records found.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SalesViewModal;
